"use client";

import { c as _c } from "react/compiler-runtime";
import { CountUp } from "@repo/design-system/components/count-up";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
import { filterTypes as by } from "@repo/design-system/types/filter";
import { cn } from "@repo/design-system/utils/cn";
import { ChevronDown } from "lucide-react";
import dynamic from "next/dynamic";
import { type CSSProperties, useState } from "react";
import { Button } from "~/components/ui/button-eon";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import { useInitialCount } from "../initial-count-provider";
import { NewsletterModal } from "../newsletter/newsletter-modal-eon";
import { ClearFilters } from "./clear-filters";
import { GeoSelect } from "./filters/geo-select-eon";
import { GroupSelect } from "./filters/group-select-eon";
import { LocationSelect } from "./filters/location-select-eon";
import { MultiSelect } from "./filters/multi-select";
import { Searchbar } from "./searchbar-eon";
import { ToggleMap } from "./toggle-map-eon";
const WatchJobs = dynamic(() => import("./watch-jobs-eon").then(m => m.WatchJobs), {
  ssr: false,
  loading: () => <Skeleton className="h-12" />
});
export default function Filterbar() {
  const $ = _c(62);
  const t = useLanguage();
  const initialCount = useInitialCount();
  const [isExpanded, setIsExpanded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      "--filterbar-bg-mobile": `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobboard/filterbar_pattern_small-compressed.webp)`,
      "--filterbar-bg-desktop": `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobboard/filterbar_pattern-compressed.webp)`
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== initialCount || $[2] !== t.filterbar_tagline) {
    t1 = <h1 className="font-bold text-5xl md:mb-2 xl:col-span-3"><CountUp initialCount={initialCount}>{" "}{t.filterbar_tagline} E.ON</CountUp></h1>;
    $[1] = initialCount;
    $[2] = t.filterbar_tagline;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden text-lg md:flex xl:col-start-4"><NewsletterModal /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <div className="grid grid-flow-row grid-cols-1 items-end gap-x-4 gap-y-4 md:grid-cols-2 xl:grid-cols-4">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t.aria_header_filterbar) {
    t4 = <h2 className="sr-only">{t.aria_header_filterbar}</h2>;
    $[7] = t.aria_header_filterbar;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Searchbar />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t.filterbar_filter1_placeholder) {
    t6 = <LocationSelect id="6" label={t.filterbar_filter1_placeholder} />;
    $[10] = t.filterbar_filter1_placeholder;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [by.JOB_FIELD];
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t.filterbar_filter4_placeholder) {
    t8 = <MultiSelect filterBy={t7} id="1" label={t.filterbar_filter4_placeholder} />;
    $[13] = t.filterbar_filter4_placeholder;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [by.ENTRY_LEVEL_MULTI];
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t.filterbar_filter2_placeholder) {
    t10 = <MultiSelect filterBy={t9} id="2" label={t.filterbar_filter2_placeholder} />;
    $[16] = t.filterbar_filter2_placeholder;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t8) {
    t11 = <div className="grid grid-flow-row grid-cols-1 items-center gap-x-4 gap-y-4 md:grid-cols-2 xl:grid-cols-4">{t5}{t6}{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = !isExpanded;
  let t13;
  if ($[22] !== t.filterbar_geosearch_label) {
    t13 = <div className="xl:col-span-2"><GeoSelect label={t.filterbar_geosearch_label} /></div>;
    $[22] = t.filterbar_geosearch_label;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [by.COMPANY];
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t.filterbar_filter6_placeholder) {
    t15 = <MultiSelect filterBy={t14} id="5" label={t.filterbar_filter6_placeholder} />;
    $[25] = t.filterbar_filter6_placeholder;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [by.EMPLOYMENT_TYPE, by.CONTRACT];
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t.filterbar_filter3_placeholder) {
    t17 = <GroupSelect filterBy={t16} id="3" label={t.filterbar_filter3_placeholder} />;
    $[28] = t.filterbar_filter3_placeholder;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t.filterbar_titleExpandFilter || $[31] !== t12 || $[32] !== t13 || $[33] !== t15 || $[34] !== t17) {
    t18 = <section aria-label={t.filterbar_titleExpandFilter} className="grid grid-flow-row grid-cols-1 items-center gap-x-4 gap-y-4 md:grid-cols-2 xl:grid-cols-4" hidden={t12} id="filterbar-more-filters">{t13}{t15}{t17}</section>;
    $[30] = t.filterbar_titleExpandFilter;
    $[31] = t12;
    $[32] = t13;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsExpanded(_temp);
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const t20 = t.filterbar_titleExpandFilter;
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div />;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = isExpanded ? t.filterbar_expandFilterLess : t.filterbar_expandFilterMore;
  const t23 = isExpanded && "rotate-180";
  let t24;
  if ($[38] !== t23) {
    t24 = cn("size-4 shrink-0 transition-transform", t23);
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t24) {
    t25 = <ChevronDown aria-hidden={true} className={t24} />;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== isExpanded || $[43] !== t.filterbar_titleExpandFilter || $[44] !== t22 || $[45] !== t25) {
    t26 = <Button aria-controls="filterbar-more-filters" aria-expanded={isExpanded} className="justify-between" id="filterbar-more-filters-toggle" onClick={t19} title={t20} type="button" variant="ghost">{t21}{t22}{t25}</Button>;
    $[42] = isExpanded;
    $[43] = t.filterbar_titleExpandFilter;
    $[44] = t22;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  let t28;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="md:hidden"><NewsletterModal /></div>;
    t28 = <ClearFilters />;
    $[47] = t27;
    $[48] = t28;
  } else {
    t27 = $[47];
    t28 = $[48];
  }
  let t29;
  let t30;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="min-h-12"><WatchJobs /></div>;
    t30 = <ToggleMap />;
    $[49] = t29;
    $[50] = t30;
  } else {
    t29 = $[49];
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t26) {
    t31 = <div className="grid h-auto grid-flow-row grid-cols-1 items-center gap-x-4 gap-y-4 text-lg md:grid-cols-2 xl:grid-cols-4">{t26}{t27}{t28}{t29}{t30}</div>;
    $[51] = t26;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  let t32;
  if ($[53] !== t.filterbar_filter10_placeholder) {
    t32 = env.ENVIRONMENT !== "production" && <div className="grid gap-x-4 md:grid-cols-4"><MultiSelect className="bg-secondary md:col-span-2 xl:col-span-1" filterBy={[by.DATA_SOURCE]} id="10" label={t.filterbar_filter10_placeholder} /></div>;
    $[53] = t.filterbar_filter10_placeholder;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== t11 || $[56] !== t18 || $[57] !== t3 || $[58] !== t31 || $[59] !== t32 || $[60] !== t4) {
    t33 = <section className="outer-container grid justify-items-center bg-center bg-cover py-container text-white" id="filterbar" style={t0 as CSSProperties} tabIndex={-1}><div className="inner-container grid gap-y-4">{t3}{t4}{t11}{t18}{t31}{t32}</div></section>;
    $[55] = t11;
    $[56] = t18;
    $[57] = t3;
    $[58] = t31;
    $[59] = t32;
    $[60] = t4;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  return t33;
}
function _temp(open) {
  return !open;
}